module.exports = __webpack_public_path__ + "img/business-licence-pic.e76efc3e.png";